import * as React from 'react'
import dynamic from 'next/dynamic'

import ImgSet from '@components/demo/ImgSet'
import {t} from '@lib/helpers'

const DualSlide = dynamic(() => import('@components/DualSlide'))
const Meta = dynamic(() => import('@components/Meta'))

const Demo = () => {
  const demos = [
    {
      img: {
        sm: '/images/demo/sm/ocr.jpg',
        md: '/images/demo/ocr.jpg',
      },
      title: t('pages.demo.index.demos.ocr.title'),
      description: t('pages.demo.index.demos.ocr.description'),
      href: '/demo/ocr',
    },
    {
      img: {
        sm: '/images/demo/sm/demographic.jpg',
        md: '/images/demo/demographic.jpg',
      },
      title: t('pages.demo.index.demos.demographic.title'),
      description: t('pages.demo.index.demos.demographic.description'),
      href: '/demo/demographic',
    },
    {
      img: {
        sm: '/images/demo/sm/object-detection.jpg',
        md: '/images/demo/object-detection.jpg',
      },
      title: t('pages.demo.index.demos.object_detection.title'),
      description: t('pages.demo.index.demos.object_detection.description'),
      href: '/demo/detection',
    },
  ]

  return (
    <React.Fragment>
      <Meta title={`${t('pages.demo.index.title')} – ${t('layout.title')}`} />

      <div className='Demo'>
        <DualSlide>
          <div className='DualSlide__wrapper DualSlide__wrapper--h1 DualSlide__wrapper--h1--blue'>
            <div className='DualSlide__wrapper__content'>
              <h1
                className='DualSlide__h2'
                dangerouslySetInnerHTML={{
                  __html: t('pages.demo.index.hero.title'),
                }}
              />

              <p className='DualSlide__p'>
                {t('pages.demo.index.hero.content1')}
                <br />
                {t('pages.demo.index.hero.content2')}
              </p>

              <div className='Buttons'>
                <a
                  className='DualSlide__a'
                  href='#demos'
                  onClick={(e) => {
                    e.preventDefault()

                    const {hash} = e.target

                    window.history.pushState(null, null, hash)
                    document
                      .querySelector(hash)
                      .scrollIntoView({behavior: 'smooth'})
                  }}
                />
              </div>
            </div>

            <div className='DualSlide__wrapper__bar'></div>
          </div>

          <div className='DualSlide__image'>
            <ImgSet
              className='DualSlide__image__img'
              src='/images/demo/hero.jpg'
              alt='AI'
            />
          </div>
        </DualSlide>

        <div className='Demo__content' id='demos'>
          <div className='container'>
            <h2
              className='Demo__h2'
              dangerouslySetInnerHTML={{
                __html: t('pages.demo.index.main.title'),
              }}
            />
            <p
              className='Demo__p'
              dangerouslySetInnerHTML={{
                __html: t('pages.demo.index.main.content'),
              }}
            />

            <ul className='Demo__list'>
              {demos.map((demo, index) => (
                <DemoItem {...demo} key={`demo-${index}`} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

const DemoItem = ({img, title, description, href}) => {
  return (
    <li className='Demo__item'>
      <div className='Demo__item__body'>
        <ImgSet
          src={img.md}
          alt={title}
          className='Demo__item__img'
          loading='lazy'
        />
        <div>
          <h4 className='Demo__item__title'>{title}</h4>
          <p className='Demo__item__description'>{description}</p>
        </div>
      </div>

      <a
        href={href}
        className='Demo__item__link'
        rel='noopener noreferrer'
        target='_blank'
      >
        <ImgSet
          src={img.sm}
          alt={title}
          className='Demo__item__link__img'
          loading='lazy'
        />
        <span>{t('pages.demo.index.demos.try_demo')}</span>
        <svg width='35' height='16' fill='currentColor' viewBox='0 0 35 16'>
          <path d='M26.996 0a.727.727 0 00-.535 1.238l5.816 6.039H.738a.726.726 0 100 1.454h31.54l-5.817 6.038a.728.728 0 001.054 1.005L35 8.004 27.515.233A.735.735 0 0026.996 0z' />
        </svg>
      </a>
    </li>
  )
}

export default Demo
